module.exports = __webpack_public_path__ + "static/EDP24-00b3bb5889b92ea6096dc1e5fe55125e.jpg";